var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled, { css } from 'styled-components';
import React from 'react';
import { muiSuccessFill, muiPlusOutline, } from '@ally/metronome-icons';
import { Icon } from '../Icon';
var EmptyCircle = styled.span(function (_a) {
    var size = _a.size, colors = _a.theme.colors;
    var isSmall = size === 'md';
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: inline-block;\n      box-sizing: border-box;\n      height: ", ";\n      width: ", ";\n      border: 1px solid ", ";\n      border-radius: 12px;\n      background-color: ", ";\n    "], ["\n      display: inline-block;\n      box-sizing: border-box;\n      height: ", ";\n      width: ", ";\n      border: 1px solid ", ";\n      border-radius: 12px;\n      background-color: ", ";\n    "])), isSmall ? '16px' : '24px', isSmall ? '16px' : '24px', colors['periwinkle-500'], colors.white);
});
var baseCircleContainerStyles = css(function (_a) {
    var size = _a.size;
    var isSmall = size === 'md';
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      box-sizing: border-box;\n      height: ", ";\n      width: ", ";\n    "], ["\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      box-sizing: border-box;\n      height: ", ";\n      width: ", ";\n    "])), isSmall ? '16px' : '24px', isSmall ? '16px' : '24px');
});
var defaultCircleContainerStyles = css(function (_a) {
    var space = _a.theme.space, align = _a.align, isTopAligned = _a.isTopAligned;
    var isInline = align === 'inline';
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    /*\n    On both inline cards and stacked cards with both an icon and a description, we want\n    the select circle to be aligned with the top of the card. Otherwise (i.e.,\n    if the card is stacked and has an icon, but no description), we want the\n    select circle to be center aligned vertically.\n     */\n    top: ", ";\n    right: ", ";\n    align-self: flex-end;\n    ", "\n  "], ["\n    position: absolute;\n    /*\n    On both inline cards and stacked cards with both an icon and a description, we want\n    the select circle to be aligned with the top of the card. Otherwise (i.e.,\n    if the card is stacked and has an icon, but no description), we want the\n    select circle to be center aligned vertically.\n     */\n    top: ", ";\n    right: ", ";\n    align-self: flex-end;\n    ", "\n  "])), isTopAligned || isInline ? space.xs : 'unset', space.xs, baseCircleContainerStyles);
});
export var SelectCircleContainer = styled.span(function (_a) {
    var hasIcon = _a.hasIcon, align = _a.align, space = _a.theme.space;
    var isStacked = align === 'stacked';
    if (!hasIcon && isStacked) {
        /**
         * In this case we want the select circle to display on the left side of
         * the card when there is no icon and the card is stacked.
         */
        return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      position: static;\n      top: initial;\n      right: initial;\n      align-self: center;\n      margin-right: ", ";\n      ", "\n    "], ["\n      position: static;\n      top: initial;\n      right: initial;\n      align-self: center;\n      margin-right: ", ";\n      ", "\n    "])), space.md, baseCircleContainerStyles);
    }
    /**
     * In all other cases, we want the select circle to be displayed on the right
     * side of the card.
     */
    return defaultCircleContainerStyles;
});
var InnerContents = function (_a) {
    var size = _a.size, icon = _a.icon, fill = _a.fill, isIcon = _a.isIcon;
    if (isIcon)
        return React.createElement(Icon, { icon: icon, size: size, fill: fill });
    return React.createElement(EmptyCircle, { size: size });
};
export var SelectCircle = function (_a) {
    var variant = _a.variant, size = _a.size, hasIcon = _a.hasIcon, isTopAligned = _a.isTopAligned, align = _a.align, isSelected = _a.isSelected, rest = __rest(_a, ["variant", "size", "hasIcon", "isTopAligned", "align", "isSelected"]);
    var isCheck = isSelected;
    var isPlus = !isSelected && variant === 'multi-select';
    var isIcon = isCheck || isPlus;
    var icon = isCheck ? muiSuccessFill : muiPlusOutline;
    var fill = isCheck ? 'bluesuedeshoes' : 'periwinkle-500';
    return (React.createElement(SelectCircleContainer, __assign({ hasIcon: hasIcon, align: align, size: size, isTopAligned: isTopAligned }, rest),
        React.createElement(InnerContents, { icon: icon, fill: fill, isIcon: isIcon, size: size })));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=SelectCircle.js.map